import '@babel/polyfill'
import 'mutationobserver-shim'
import Vue from 'vue'
import './plugins/bootstrap-vue'
import App from './App.vue'
import router from './router'
import Vuelidate from 'vuelidate'
import VuelidateErrorExtractor, { templates } from "vuelidate-error-extractor";
import FormGroup from '@/components/templates/FormGroup';
import MultiError from '@/components/templates/MultiError';
import VueLogger from 'vuejs-logger';
import errorResponseHandler from "@/services/errorResponseHandler";
import upperFirst from 'lodash/upperFirst'
import camelCase from 'lodash/camelCase'

import titleMixin from './mixins/titleMixin.js'
Vue.mixin(titleMixin)

import JsonExcel from 'vue-json-excel'
Vue.component("downloadExcel", JsonExcel)


import Axios from '@/plugins/axios-plugin';
import { store } from './store/store'
import vSelect from 'mdh-vue-select'


import i18n from './i18n'
import moment from 'moment'

import VueTheMask from 'vue-the-mask'

import Toast from 'vue-toastification'
import 'vue-toastification/dist/index.css'


Vue.use(Toast, {
  transition: 'Vue-Toastification__bounce',
  maxToasts: 20,
  newestOnTop: true
})

Vue.use(VueTheMask)

Vue.config.productionTip = false
Vue.use(Vuelidate)

Vue.component('v-select', vSelect)

Vue.use(VuelidateErrorExtractor, {
  i18n: false,
  template: FormGroup,
  messages: {
    required: "{attribute} is required.",
    email: "{attribute} is not a valid Email Address.",
    numeric: "{attribute} must be a numeric value.",
    checked: "{attribute}",
    minDate: "{attribute} is before the minimum allowed date.",
    maxDate: "{attribute} is after the maximum allowed date.",
    maxLength: "{attribute} exceeds the maximum length.",
    isValid: "{attribute} is not formatted correctly."
  },
  attributes: {

  }
});

Vue.component('form-summary', MultiError)

Vue.filter('formatDate', function(value) {
  if (value) {
    return moment(String(value)).format('MM/DD/YYYY')
  }
});

Vue.filter('formatTime', function(value) {
  if (value) {
    return moment(String(value)).format('h:mm a')
  }
});


const options = {
  isEnabled: true,
  logLevel : Vue.config.productionTip  ? 'error' : 'debug',
  stringifyArguments : false,
  showLogLevel : true,
  showMethodName : true,
  separator: '|',
  showConsoleColors: true
};

Vue.use(VueLogger, options);
Vue.use(Axios)

const requireComponent = require.context(
    './components',
    false,
    /Base[A-Z]\w+\.(vue|js)$/
)

requireComponent.keys().forEach(fileName => {
  const componentConfig = requireComponent(fileName)
  const componentName = upperFirst(
      camelCase(
          fileName.replace(/^\.\/(.*)\.\w+$/, '$1')
      )
  )

  Vue.component(
      componentName,
      componentConfig.default || componentConfig
  )
})

new Vue({
  router,
  store,
  i18n,
  render: h => h(App)
}).$mount('#app')
